import React, {useMemo} from 'react'
import usePageTitle from '@/hooks/usePageTitle'
import {useParams} from 'react-router-dom'
import {LabelWithoutJson} from '@/components/atoms'
import {FONT_SIZE, FONT_WEIGHT} from '@/shared/constants/globalStyle'
import PropTypes from 'prop-types'
/**
 * PageHeader component displays a header with a title and optional children.
 * It also sets the page title using the `usePageTitle` hook.
 *
 * @param {Object} props - The component props.
 * @param {string} props.title - The title to display in the header.
 * @param {string} [props.className] - Additional class names to apply to the header container.
 *
 * @returns {JSX.Element} The rendered PageHeader component.
 */
const PageHeader = ({title, fontSize = FONT_SIZE.XXXXL, color = 'var(--color-text-primary)'}) => {
  const params = useParams()
  const pageTitle = useMemo(() => {
    const {id} = params
    const pageSubContext = id ? ` [${id}]` : ''
    return title + pageSubContext
  }, [params, title])

  usePageTitle(pageTitle)
  return (
    <div className={`position-relative mb-5 mt-5  flex  items-center gap-4 font-bold`}>
      <LabelWithoutJson text={title} fontWeight={FONT_WEIGHT.BOLD} fontSize={fontSize} color={color} />
    </div>
  )
}

PageHeader.propTypes = {
  title: PropTypes.string,
  fontSize: PropTypes.string,
  color: PropTypes.string,
}

export default PageHeader
